import React from "react";
import ChildWhiteboard from "../ChildWhiteboard";

const TabulaWorkspace = ({
    isExpanded,
    workspaceMode,
    sharedStatus,
    onSharedEditing,
    sharedWorkspace,
    activeFolderId,
    childId,
    scope,
    title,
    handleSharedTabulaChange,
}) => {
    return (
        <div
            className="
                h-full
                min-h-0
                overflow-visible
                rounded-2xl
                border
                border-[#ffd166]/15
                bg-[#080b14]
            "
        >
            <div
                className={`
                    ${
                        isExpanded
                            ? "h-[1000px] min-h-[1000px] min-w-[1400px]"
                            : "h-[760px] min-h-[760px] min-w-[900px]"
                    }
                    [&>div]:h-full
                    [&_.excalidraw]:h-full
                `}
            >
                {workspaceMode === "shared" &&
                sharedStatus === "loading" ? (
                    <div
                        className="
                            flex
                            h-full
                            min-h-[520px]
                            items-center
                            justify-center
                            rounded-2xl
                            border
                            border-[#7cc1ff]/25
                            bg-[#080b14]
                            text-sm
                            text-[#9dcff5]
                        "
                    >
                        Opening shared Tabula...
                    </div>
                ) : (
                    <ChildWhiteboard
                        key={`${workspaceMode}_${
                            activeFolderId || "general"
                        }_${
                            workspaceMode === "shared"
                                ? sharedWorkspace?.workspace_id ||
                                  "shared"
                                : "private"
                        }`}
                        childId={childId}
                        scope={`${scope}_${
                            activeFolderId ||
                            "general"
                        }`}
                        title={`${title} · Tabula`}
                        workspaceMode={
                            workspaceMode
                        }
                        sharedWorkspace={
                            sharedWorkspace
                        }
                        onSharedEditing={onSharedEditing}
                        onSharedDataChange={
                            handleSharedTabulaChange
                        }
                    />
                )}
            </div>
        </div>
    );
};

export default TabulaWorkspace;